import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Media from 'local_modules/Media'

import s from './Cell.scss'


const Cell = ({
  children, className, tag, columns, size, gutter, role, tabIndex,
  align, center, left, style = {},
  onClick,
}) => {
  const rootClassName = cx(s.cell, className, {
    [s[`gutter_${gutter}`]]: gutter, // gutter_xlg, ...
    [s.center]: center,
    [s.left]: left,
    [s[`align-${align}`]]: align,
  })

  if (size && typeof size === 'object') {
    return (
      <Fragment>
        {
          Object
            .keys(size)
            .map((media) => {
              const mediaType = { [media]: true }
              const style     = { flexBasis: `${(size[media] >= columns ? 1 : size[media] / columns) * 100}%`, ...style }

              const props = {
                role: 'listitem',
                className: rootClassName,
                style,
                tabIndex,
                onClick,
              }

              return (
                <Media key={media} {...mediaType}>
                  {
                    (isMatches) => isMatches && React.createElement(tag, props, children)
                  }
                </Media>
              )
            })
        }
      </Fragment>
    )
  }

  const width = `${(size >= columns ? 1 : size / columns) * 100}%`

  const props = {
    role,
    className: rootClassName,
    style: size ? { flexBasis: width, width, ...style } : style,
    tabIndex,
    onClick,
  }

  return React.createElement(tag, props, children)
}

Cell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.string,
  columns: PropTypes.number,
  tabIndex: PropTypes.number,
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object,
  ]),
  gutter: PropTypes.oneOf([
    'xsm', 'sm', 'md', 'lg', 'xlg',
    4, 8, 12, 16, 20, 24,
  ]),
}

Cell.defaultProps = {
  tag: 'div',
  columns: 1,
  size: 1,
  role: 'listitem',
}


export default Cell
